module.exports = __webpack_public_path__ + "img/index_user.88e89a18.png";